// extracted by mini-css-extract-plugin
export default {"container":"NetworkGuard_container_YX1sz","body":"NetworkGuard_body_2S3OM","line":"NetworkGuard_line_3yUfN"};